// ABOUTME: Helpers for the report bar charts' x-axis label positioning, deciding when the
// ABOUTME: first/last labels may be pinned to the plot edges instead of centered under their bars.

// Pinning the edge labels only makes sense when the chart is wider than its scroll container:
// there the outermost labels sit against the plot edges and would otherwise be clipped. When the
// chart fits, every label is centered under its own (wide) category slot and must stay put —
// pinning would drag it away from its bar. The 1px tolerance absorbs sub-pixel width rounding.
export const shouldPinEdgeAxisLabels = (container) => {
    if (!container) return false;
    return container.scrollWidth > container.clientWidth + 1;
};
